/**
 * `clientDashboard` — `mockups/client/dashboard.html`, the whole page in one call.
 *
 * `.docs/17-studio-read-models.md` §C: "`client-dashboard` = metrics (16) + allowances
 * (12) + decisions + upcoming — composed here so the page makes one call." Nothing is
 * computed in this file: every field is one of session 16's or this session's own
 * read models, unchanged, which is what makes the composition free to get wrong in
 * only one place — `readmodels/client-dashboard.ts` — rather than in every page that
 * wants the same four things.
 */
import { z } from 'zod';
import { ClientMetricsSchema } from '../reports.js';
import { AllowanceStatusSchema } from '../retainers.js';
import { ClientDecisionsSchema } from './decisions.js';
import { ClientUpcomingSchema } from './upcoming.js';
import { ClientRecentlyDeliveredSchema, ClientWorkItemSchema } from './work.js';
export const ClientDashboardSchema = z
    .strictObject({
    metrics: ClientMetricsSchema.describe('§1 Performance — session 16’s `clientMetrics`, unchanged.'),
    allowances: z
        .array(AllowanceStatusSchema)
        .describe('§2 Allowances — session 12’s `retainers.allowanceStatus`, unchanged.'),
    decisions: ClientDecisionsSchema.describe('§3 Approvals — this session’s `clientDecisions`.'),
    upcoming: ClientUpcomingSchema.describe('§4 Upcoming — this session’s `clientUpcoming`.'),
    /*
     * Session 41's two, from `readmodels/client-work.ts`. They are spread in at the
     * top level rather than nested under a `work` key because the page draws them as
     * two separate blocks in two separate places in its order, and a wrapper whose
     * only job is to be destructured on arrival is a shape nobody reads.
     */
    work_in_progress: z
        .array(ClientWorkItemSchema)
        .describe('What the studio is working on now — session 41’s `clientWork`.'),
    recently_delivered: ClientRecentlyDeliveredSchema.describe('What landed this month — the same read model’s other half.'),
})
    .describe('Everything the client dashboard shows, in one answer so the page makes one call.');
//# sourceMappingURL=dashboard.js.map